import './user_ranking_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.ModerationRankingChartView extends Monitoring.Views.Charts.UserRankingChartView
  className: 'chart-ranking moderation-ranking item w2 h3'
  tabs: 3

  initialize: (@options = {}) ->
    @filename = 'user_ranking.png'
    super

  getRankingList: ->
    [
      { id:'user_ranking', title:I18n.t('monitoring.dashboard.charts.user_ranking') },
      { id:'approved_user_ranking_chart', title:I18n.t('monitoring.dashboard.charts.ranking.most_approved'), status:'approved' },
      { id:'rejected_user_ranking_chart', title:I18n.t('monitoring.dashboard.charts.ranking.most_rejected'), status:'rejected' }
    ]
